import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/reducers";
import { Button, Col, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useSignUpForm } from './useSignUpForm';
import { FormColumn } from "../Generic";
import { OfcaTermsAndPolicy } from "./OfcaTermsAndPolicy";
import { useAuth0 } from '@auth0/auth0-react';
import Condition from "../../Common/Condition";
import { signupUserInit } from "../../../store/actions";
import { reactPlugin } from "../../../utils/logger/AppInsights";

export const SignUpForm = () => {
  const { t } = useTranslation();
  const { isLoading, loginWithRedirect} = useAuth0();
  const {sections, actions} = useSignUpForm();
  const [termsAgreed, setTermsAgreed] = useState(false);
  const {signup: signUpState, loginError: signupError, loading: waitingSignup } = useSelector((state: RootState) => state.Login);
    
    useEffect(() => {
      if (signupError !== undefined) {
        const customError = new Error('SignUpError: ' + signupError);
        reactPlugin.trackException({
          error: customError,
        });
      }
    }, [signupError]);

  useEffect(() => { 
    if(isLoading)
      signupUserInit(); 
  },[isLoading]);

  return (
    <>
      <form onSubmit={actions.submit}>
          <fieldset>
              <Row>
                  {sections.map((section, idx) => <FormColumn key={idx} {...section}/>)}
              </Row>
              <Row>
                  <Col>
                    <OfcaTermsAndPolicy
                      termsAgreed={termsAgreed}
                      setTermsAgreed={setTermsAgreed}/>
                      <Condition rule={!signUpState}>
                      <Button 
                      className="clickbutton" 
                      type="button" 
                      color="primary" 
                      disabled={!termsAgreed}
                      onClick={actions.submit}>
                        {t("Sign Up")}
                      </Button>
                      </Condition>
                      <Condition rule={!waitingSignup && signUpState}>
                        <div className="additional"> 
                        Success! You can now 
                        <span className="login-link" onClick={() => loginWithRedirect({ 
                          appState: { targetUrl: window.location.origin },
                          authorizationParams: {
                            email: actions.getValues("email"),
                            password: actions.getValues("password")
                          }})}> log into</span> Ofca.
                        </div>
                      </Condition>
                      <Condition rule={!waitingSignup && !signUpState && signupError!==undefined}>
                        <div className="additional"> 
                          We already have you as a member so please try to <span className="login-link" onClick={() => loginWithRedirect({ appState: { targetUrl: window.location.origin } })}>log in</span>, in case issue persists please contact us via contact@ofca.io
                        </div>
                      </Condition>
                      <Condition rule={!waitingSignup && !signUpState}>
                        <div className="additional"> 
                            Already a member? Please <span className="login-link" onClick={() => loginWithRedirect({ appState: { targetUrl: window.location.origin } })}>log in</span>
                        </div>
                      </Condition>
                  </Col>
              </Row>
          </fieldset>
      </form>
    </>
  );
};
